export const GET_RESTAURANT_SETTINGS_API = "/public/get-restaurant-settings/";

export const GET_CLOSED_DAYS_API = "/public/get-closed-days/";

export const GET_SHIFTS_API = "/public/get-shifts/";

export const GET_DEFAULT_SHIFTS_API = "/public/get-default-shifts/";

export const GET_OPENING_HOURS_API = "/public/get-opening-hours/";

export const GET_MAX_SEATS_API = "/public/get-max-seats/";

export const GET_CURRENT_RESERVATION_API = "/public/get-customer-reservation/";

export const CHECK_AVAILABILITY_API = "/public/check-availability/";

export const CONFIRM_RESERVATION_API = "/public/confirm-customer-reservation/";

export const CANCEL_RESERVATION_API = "/public/cancel-reservation/";

export const CONTACT_RESTAURANT_API = "/public/contact-restaurant/";

export const CONFIRM_ORDER_API = "/shop/create-order/";

export const CHECK_DISTANCE_API = "/shop/check-distance/";

export const GET_ORDER_SETTINGS_API = "/shop/public-settings/";

export const CREATE_PAYMENT_INTENT_API = "/shop/create-payment-intent/";

export const CREATE_PAYMENT_SOURCE_API = "/shop/create-payment-source/";

export const CREATE_UPON_PICKUP_PAYMENT_API = "/shop/create-upon-pickup-payment/";

export const GET_CURRENT_ORDER_API = "/public/get-customer-order/";

export const CANCEL_ORDER_API = "/public/cancel-order/";

export const GET_SURVEYS_API = "/public/surveys/default/";

export const ANSWER_SURVEY_API = (id) => `/public/surveys/${id}/answer/`;

export const ANSWER_BARESTHO_SURVEY_API = "/public/barestho-survey/answer/";

export const GET_SURVEYS_STATUS_API = "/public/get-surveys-status/";



// WEBPACK FOOTER //
// ./src/apis.js